import axios from "axios";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { getAccessToken } from "./GetToken";

export const postData = async(url,data,message = false,auth = false)=>{
    if(!message){
        const response = await sendPostRequest(url,data, auth);
        if(!response) return false;
        const {message} = response.data;
        if(response.status === 201){
            if(!auth) displayMessage(`${message}`, true);
            return true;
        }else{
            return false;
        }
    }else{
        const result = await Swal.fire({
            title: `${message}`,
            showDenyButton: true,
            confirmButtonText: `Procced`,
            denyButtonText: `Cancel`,
          });
        //   console.log(result);
        if(result.isConfirmed) {
            const response = await sendPostRequest(url,data, auth);
            if(!response) {
                displayMessage();
                return false;
            }
            const {message} = response.data;
            if(response.status === 201){
                if(!auth) displayMessage(`${message}`, true);
                return true;
            }else{
                return false;
            }
        }
    }
}

const sendPostRequest = async(url,data,auth = false)=>{
    try{
        let response;
        if(!auth){
            response = await axios.post(`${url}`,data , {headers: {Authorization: `Bearer ${getAccessToken()}`}});
            // console.log(localStorage.getItem('accessToken'))
        }else{
            response = await axios.post(`${url}`,data);
        }
        // console.log(response);
        if(auth) {
            const {accessToken} = response.data;
            localStorage.setItem('accessToken',accessToken);
        }
        return response;
    }
    catch(error){
        console.log(error);
        return false;
        displayMessage();
    }
}

const displayMessage = async(message = 'There was some problem',success = false)=>{
    if(success) swal("Great!", `${message}`, "success");
    else swal("Sorry!", `There was some problem`, "warning");
}

export const fetchData = async(url)=>{
    try{
        const response = await axios.get(`${url}`);
        const {data} = response;
        // console.log(response);
        return data;
    }
    catch(error){
        console.log(error);
        swal("Sorry!", `There was some problem`, "warning");
    }
}

export const removeItem = async (url,data)=>{
    try{
        const response = await axios.get(`${url}`,data);
        const {data} = response;
        return data;
    }
    catch(error){
        console.log(error);
        swal("Sorry!", `There was some problem`, "warning");
    }
}